import { render, staticRenderFns } from "./Maze.vue?vue&type=template&id=4b503d40&scoped=true&"
import script from "./Maze.vue?vue&type=script&lang=js&"
export * from "./Maze.vue?vue&type=script&lang=js&"
import style0 from "./Maze.vue?vue&type=style&index=0&id=4b503d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b503d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContent,VFlex,VIcon,VTextField})
